prodproApp.controller('SetupstepController', ['$scope','$http', '$location', '$modal', '$log', '$timeout', 'alertService', function ($scope, $http, $location, $modal, $log, $timeout, alertService) {
    var vm = this;
    var base_url = api_prefix + 'setupsteps/list';
    vm.sort_url = api_prefix + 'setupsteps/sort';
    vm.resource_url = api_prefix + 'setupsteps';
    vm.objText = {
        singular: 'setup step',
        plural: 'setup steps'
    };
    vm.file_model = 'App\\Repos\\Setupsteps\\Setupstep';

    // Mixin Module functionality.
    angular.extend(this, new ModuleController(vm, base_url, $http, $location, $log, $modal));
    angular.extend(this, new SortController(vm, $http, $modal, $timeout));

    vm.acceptedFiles = 'image/jpg,image/jpeg,image/png,image/gif';
    angular.extend(this, new FileController(vm, $scope, $http, $modal, $timeout));

    //Set up default object
    vm.initDefaultObj = function() {
        vm.defaultObj.notes = "";
    };

    vm.loadDataSuccess = function() {
        setTimeout(function(){
            turnOnTooltips();
        }, 10);
    };

    vm.sortSuccess = function() {
    };

    vm.loadData();

    //******************************************************************************


}]);